import { render } from "./externalEmbed.vue?vue&type=template&id=0dae1dd6"
import script from "./externalEmbed.vue?vue&type=script&lang=js"
export * from "./externalEmbed.vue?vue&type=script&lang=js"

import "./externalEmbed.vue?vue&type=style&index=0&id=0dae1dd6&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__